/**
 * Formik lot shape for order reception.
 *
 * OrderModal rebuilds Formik items whenever batch, expiry, quantity, or status
 * changes (`enableReinitialize` and "Mark all as Received OK"). The storage
 * place has to travel with that rebuild, or the picker and the save payload
 * lose `storage_node_id` / `slot_index`.
 *
 * Accepts the modal's camelCase lot (`storageNodeId`, `slotIndex`) and the
 * order-detail lot (`storage_node_id`, `slot_index`).
 *
 * @param {Object|null|undefined} lot
 * @returns {{ batch: *, expiry: *, lotItemQuantity: string, storageNodeId: string|number|null, slotIndex: number|null }}
 */
export function mapReceptionLotToFormLot(lot) {
  const rawId = lot?.storageNodeId ?? lot?.storage_node_id;
  const storageNodeId = rawId == null || rawId === '' ? null : rawId;
  const rawSlot = lot?.slotIndex ?? lot?.slot_index;
  const slotNumber = rawSlot == null || rawSlot === '' ? null : Number(rawSlot);

  return {
    batch: lot?.batch,
    expiry: lot?.expiry,
    lotItemQuantity:
      lot?.lotItemQuantity != null ? String(lot.lotItemQuantity) : '',
    storageNodeId,
    slotIndex: Number.isInteger(slotNumber) ? slotNumber : null,
  };
}
